import Link from "next/link"

import AwsImage from "components/dashboard/AwsImage"
import Hero from "components/Hero"
import Layout, { Container, Section } from "components/Layout"
import SEO from "components/Seo"
import { prisma } from "lib/prisma"
import { slugify } from "utils/helpers"

import type { GetStaticProps, NextPage } from "next"
import type { PostWithImagesAndAuthor } from "pages/api/post/read"

const CaseStudies: NextPage<{
  posts: PostWithImagesAndAuthor[]
}> = ({ posts }) => {
  return (
    <>
      <SEO
        pageTitle="Case Studies"
        titleTag={`Case Studies | ${process.env.NEXT_PUBLIC_SITE_NAME}`}
        metaDescription=""
      />
      <Layout>
        <Hero heading="Case Studies" />
        <Section>
          <Container className="grid mdmin:grid-cols-3 gap-4">
            {posts.map(post => (
              <Link
                key={post?.id}
                href={`/case-studies/${slugify(post?.title || "")}`}
                className="relative hover:scale-105 transition-transform aspect-square"
              >
                {post?.images && post.images.length > 0 && (
                  <AwsImage
                    image={post.images[0]}
                    alt={post?.title}
                    sizes="(max-width: 767px) 80vw, 20vw"
                    className="w-full h-full object-cover"
                  />
                )}
                <div className="absolute w-full h-full left-0 top-0 bg-gradient-to-tr from-black via-transparent to-transparent" />
                <p className="my-0 absolute bottom-3 left-3 right-3 text-white">
                  {post?.title}
                </p>
              </Link>
            ))}
          </Container>
        </Section>
      </Layout>
    </>
  )
}

export const getStaticProps: GetStaticProps = async () => {
  const posts = await prisma.post.findMany({
    where: {
      published: true
    },
    orderBy: {
      createdAt: "desc"
    },
    include: {
      author: {
        select: {
          name: true,
          email: true
        }
      },
      images: {
        take: 1
      }
    }
  })

  if (!posts) return { notFound: true }

  return {
    props: {
      posts: JSON.parse(JSON.stringify(posts))
    }
  }
}

export default CaseStudies
